import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, map } from 'rxjs';
import { DialogService } from './services/dialog.service';
import { Location } from '@angular/common';
import { WebviewService } from './services/webview.service';
import { StorageEnum } from './shared/enum/storage';
import { AuthService } from './services/auth.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => Observable<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard
  implements CanDeactivate<ComponentCanDeactivate> {
  constructor(private dialog: DialogService, private router: Router, private location: Location, 
    protected authService: AuthService, protected webViewService: WebviewService) { }

  protected goToCurrent(currentRoute: ActivatedRouteSnapshot) {
    const currentUrlFragments = currentRoute.pathFromRoot.flatMap((s) => s?.url ?? []).map((s) => s.path)
    const currentUrlTree = this.router.createUrlTree([...currentUrlFragments, '../']);
    let currentUrl = currentUrlTree.toString();
    // currentUrl = this.router.createUrlTree(['../', { outlets: { edit: null } }], { queryParams: {} }).toString();
    this.location.go(currentUrl);
  }

  canDeactivate(
    component: ComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    if (component.canDeactivate()) return true;
    return this.dialog.confirmLeavePage()
      .pipe(map((result: any) => {
        if (!result) this.goToCurrent(currentRoute);
        this.webViewService.kidsConfirmDialogIntercepter(false);
        return result;
      }));
  }
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuardWebview extends CanDeactivateGuard {

  get isForceReload() {
    const info = sessionStorage.getItem(StorageEnum.FORCE_RELOAD) || '';
    return info.toLocaleLowerCase() === 'true';
  }

  protected removeForceReload() {
    sessionStorage.removeItem(StorageEnum.FORCE_RELOAD);
  }

  override canDeactivate(component: ComponentCanDeactivate, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | boolean | UrlTree {
    // force reload/ redirect
    if (this.webViewService.isWebView) {
      if (this.isForceReload) {
        this.removeForceReload();
        return true;
      }

      if (!this.authService.isAuthenticated()) {
        // this.goToCurrent(currentRoute);
        return false;
      }
    }
    return super.canDeactivate(component, currentRoute, currentState, nextState);
  }
}
